/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  LessonCreate,
  LessonOrderItem,
  LessonRead,
  LessonUpdate,
  TutorialCreate,
  TutorialRead,
  TutorialTagRead,
  TutorialUpdate,
  TutorialWithLessons,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    LessonCreateFromJSON,
    LessonCreateToJSON,
    LessonOrderItemFromJSON,
    LessonOrderItemToJSON,
    LessonReadFromJSON,
    LessonReadToJSON,
    LessonUpdateFromJSON,
    LessonUpdateToJSON,
    TutorialCreateFromJSON,
    TutorialCreateToJSON,
    TutorialReadFromJSON,
    TutorialReadToJSON,
    TutorialTagReadFromJSON,
    TutorialTagReadToJSON,
    TutorialUpdateFromJSON,
    TutorialUpdateToJSON,
    TutorialWithLessonsFromJSON,
    TutorialWithLessonsToJSON,
} from '../models/index';

export interface AssignTutorialTagsRequest {
    tutorialId: string;
    requestBody: Array<string | null>;
}

export interface CreateLessonRequest {
    tutorialId: string;
    lessonCreate: LessonCreate;
}

export interface CreateTutorialRequest {
    tutorialCreate: TutorialCreate;
}

export interface DeleteLessonRequest {
    tutorialId: string;
    lessonId: string;
}

export interface DeleteTutorialRequest {
    tutorialId: string;
}

export interface GetLessonRequest {
    tutorialId: string;
    lessonId: string;
}

export interface GetTutorialRequest {
    tutorialId: string;
}

export interface ListLessonsRequest {
    tutorialId: string;
    includeDeleted?: boolean;
}

export interface ListTutorialTagsRequest {
    skip?: number;
    limit?: number;
    search?: string | null;
}

export interface ListTutorialsRequest {
    skip?: number;
    limit?: number;
    language?: string | null;
    field?: string | null;
    tagId?: string | null;
    search?: string | null;
    organizationId?: string | null;
    includeDeleted?: boolean;
}

export interface ReorderLessonsRequest {
    tutorialId: string;
    lessonOrderItem: Array<LessonOrderItem>;
}

export interface UpdateLessonRequest {
    tutorialId: string;
    lessonId: string;
    lessonUpdate: LessonUpdate;
}

export interface UpdateTutorialRequest {
    tutorialId: string;
    tutorialUpdate: TutorialUpdate;
}

/**
 * 
 */
export class TutorialsApi extends runtime.BaseAPI {

    /**
     * Assign tags to a tutorial.  **Authorization:** Only tutorial creator or superadmins.
     * Assign Tutorial Tags
     */
    async assignTutorialTagsRaw(requestParameters: AssignTutorialTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TutorialRead>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling assignTutorialTags().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling assignTutorialTags().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}/tags`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TutorialReadFromJSON(jsonValue));
    }

    /**
     * Assign tags to a tutorial.  **Authorization:** Only tutorial creator or superadmins.
     * Assign Tutorial Tags
     */
    async assignTutorialTags(requestParameters: AssignTutorialTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TutorialRead> {
        const response = await this.assignTutorialTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new lesson in a tutorial.  **Authorization:** Only tutorial creator or superadmins.
     * Create Lesson
     */
    async createLessonRaw(requestParameters: CreateLessonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LessonRead>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling createLesson().'
            );
        }

        if (requestParameters['lessonCreate'] == null) {
            throw new runtime.RequiredError(
                'lessonCreate',
                'Required parameter "lessonCreate" was null or undefined when calling createLesson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}/lessons`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LessonCreateToJSON(requestParameters['lessonCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LessonReadFromJSON(jsonValue));
    }

    /**
     * Create a new lesson in a tutorial.  **Authorization:** Only tutorial creator or superadmins.
     * Create Lesson
     */
    async createLesson(requestParameters: CreateLessonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LessonRead> {
        const response = await this.createLessonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new tutorial.  **Authorization:** Content creators, administrators, or superadmins.
     * Create Tutorial
     */
    async createTutorialRaw(requestParameters: CreateTutorialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TutorialRead>> {
        if (requestParameters['tutorialCreate'] == null) {
            throw new runtime.RequiredError(
                'tutorialCreate',
                'Required parameter "tutorialCreate" was null or undefined when calling createTutorial().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TutorialCreateToJSON(requestParameters['tutorialCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TutorialReadFromJSON(jsonValue));
    }

    /**
     * Create a new tutorial.  **Authorization:** Content creators, administrators, or superadmins.
     * Create Tutorial
     */
    async createTutorial(requestParameters: CreateTutorialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TutorialRead> {
        const response = await this.createTutorialRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft delete a lesson.  **Authorization:** Only tutorial creator or superadmins.
     * Delete Lesson
     */
    async deleteLessonRaw(requestParameters: DeleteLessonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling deleteLesson().'
            );
        }

        if (requestParameters['lessonId'] == null) {
            throw new runtime.RequiredError(
                'lessonId',
                'Required parameter "lessonId" was null or undefined when calling deleteLesson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}/lessons/{lesson_id}`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))).replace(`{${"lesson_id"}}`, encodeURIComponent(String(requestParameters['lessonId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete a lesson.  **Authorization:** Only tutorial creator or superadmins.
     * Delete Lesson
     */
    async deleteLesson(requestParameters: DeleteLessonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLessonRaw(requestParameters, initOverrides);
    }

    /**
     * Soft delete a tutorial.  **Authorization:** Only tutorial creator or superadmins.
     * Delete Tutorial
     */
    async deleteTutorialRaw(requestParameters: DeleteTutorialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling deleteTutorial().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete a tutorial.  **Authorization:** Only tutorial creator or superadmins.
     * Delete Tutorial
     */
    async deleteTutorial(requestParameters: DeleteTutorialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTutorialRaw(requestParameters, initOverrides);
    }

    /**
     * Get a lesson by ID.  Lessons are only visible if the parent tutorial is accessible.
     * Get Lesson
     */
    async getLessonRaw(requestParameters: GetLessonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LessonRead>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling getLesson().'
            );
        }

        if (requestParameters['lessonId'] == null) {
            throw new runtime.RequiredError(
                'lessonId',
                'Required parameter "lessonId" was null or undefined when calling getLesson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}/lessons/{lesson_id}`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))).replace(`{${"lesson_id"}}`, encodeURIComponent(String(requestParameters['lessonId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LessonReadFromJSON(jsonValue));
    }

    /**
     * Get a lesson by ID.  Lessons are only visible if the parent tutorial is accessible.
     * Get Lesson
     */
    async getLesson(requestParameters: GetLessonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LessonRead> {
        const response = await this.getLessonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a tutorial by ID with its lessons.  **Authorization:** Requires authentication. - Public tutorials: All logged-in users - Private tutorials: Only creator and superadmins - Organization tutorials: Users in that org, creator, and superadmins
     * Get Tutorial
     */
    async getTutorialRaw(requestParameters: GetTutorialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TutorialWithLessons>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling getTutorial().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TutorialWithLessonsFromJSON(jsonValue));
    }

    /**
     * Get a tutorial by ID with its lessons.  **Authorization:** Requires authentication. - Public tutorials: All logged-in users - Private tutorials: Only creator and superadmins - Organization tutorials: Users in that org, creator, and superadmins
     * Get Tutorial
     */
    async getTutorial(requestParameters: GetTutorialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TutorialWithLessons> {
        const response = await this.getTutorialRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all lessons in a tutorial.  Lessons are only visible if the parent tutorial is accessible.
     * List Lessons
     */
    async listLessonsRaw(requestParameters: ListLessonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LessonRead>>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling listLessons().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeDeleted'] != null) {
            queryParameters['include_deleted'] = requestParameters['includeDeleted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}/lessons`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LessonReadFromJSON));
    }

    /**
     * List all lessons in a tutorial.  Lessons are only visible if the parent tutorial is accessible.
     * List Lessons
     */
    async listLessons(requestParameters: ListLessonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LessonRead>> {
        const response = await this.listLessonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all available tutorial tags.  Anyone can list tags. This endpoint is public.
     * List Tutorial Tags
     */
    async listTutorialTagsRaw(requestParameters: ListTutorialTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TutorialTagRead>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/tutorials/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TutorialTagReadFromJSON));
    }

    /**
     * List all available tutorial tags.  Anyone can list tags. This endpoint is public.
     * List Tutorial Tags
     */
    async listTutorialTags(requestParameters: ListTutorialTagsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TutorialTagRead>> {
        const response = await this.listTutorialTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List tutorials with optional filtering.  **Authorization:** Requires authentication. - Superadmins: Can see all tutorials - Regular users: Public tutorials + their own + organization tutorials they belong to
     * List Tutorials
     */
    async listTutorialsRaw(requestParameters: ListTutorialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TutorialRead>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['tagId'] != null) {
            queryParameters['tag_id'] = requestParameters['tagId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['includeDeleted'] != null) {
            queryParameters['include_deleted'] = requestParameters['includeDeleted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TutorialReadFromJSON));
    }

    /**
     * List tutorials with optional filtering.  **Authorization:** Requires authentication. - Superadmins: Can see all tutorials - Regular users: Public tutorials + their own + organization tutorials they belong to
     * List Tutorials
     */
    async listTutorials(requestParameters: ListTutorialsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TutorialRead>> {
        const response = await this.listTutorialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reorder lessons in a tutorial.  **Authorization:** Only tutorial creator or superadmins.  The body lists each lesson\'s id with its new non-negative `order`. Example: [{\"lesson_id\": \"uuid1\", \"order\": 0}, {\"lesson_id\": \"uuid2\", \"order\": 1}]
     * Reorder Lessons
     */
    async reorderLessonsRaw(requestParameters: ReorderLessonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LessonRead>>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling reorderLessons().'
            );
        }

        if (requestParameters['lessonOrderItem'] == null) {
            throw new runtime.RequiredError(
                'lessonOrderItem',
                'Required parameter "lessonOrderItem" was null or undefined when calling reorderLessons().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}/lessons/reorder`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['lessonOrderItem']!.map(LessonOrderItemToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LessonReadFromJSON));
    }

    /**
     * Reorder lessons in a tutorial.  **Authorization:** Only tutorial creator or superadmins.  The body lists each lesson\'s id with its new non-negative `order`. Example: [{\"lesson_id\": \"uuid1\", \"order\": 0}, {\"lesson_id\": \"uuid2\", \"order\": 1}]
     * Reorder Lessons
     */
    async reorderLessons(requestParameters: ReorderLessonsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LessonRead>> {
        const response = await this.reorderLessonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a lesson.  **Authorization:** Only tutorial creator or superadmins.
     * Update Lesson
     */
    async updateLessonRaw(requestParameters: UpdateLessonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LessonRead>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling updateLesson().'
            );
        }

        if (requestParameters['lessonId'] == null) {
            throw new runtime.RequiredError(
                'lessonId',
                'Required parameter "lessonId" was null or undefined when calling updateLesson().'
            );
        }

        if (requestParameters['lessonUpdate'] == null) {
            throw new runtime.RequiredError(
                'lessonUpdate',
                'Required parameter "lessonUpdate" was null or undefined when calling updateLesson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}/lessons/{lesson_id}`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))).replace(`{${"lesson_id"}}`, encodeURIComponent(String(requestParameters['lessonId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LessonUpdateToJSON(requestParameters['lessonUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LessonReadFromJSON(jsonValue));
    }

    /**
     * Update a lesson.  **Authorization:** Only tutorial creator or superadmins.
     * Update Lesson
     */
    async updateLesson(requestParameters: UpdateLessonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LessonRead> {
        const response = await this.updateLessonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a tutorial.  **Authorization:** Only tutorial creator or superadmins.
     * Update Tutorial
     */
    async updateTutorialRaw(requestParameters: UpdateTutorialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TutorialRead>> {
        if (requestParameters['tutorialId'] == null) {
            throw new runtime.RequiredError(
                'tutorialId',
                'Required parameter "tutorialId" was null or undefined when calling updateTutorial().'
            );
        }

        if (requestParameters['tutorialUpdate'] == null) {
            throw new runtime.RequiredError(
                'tutorialUpdate',
                'Required parameter "tutorialUpdate" was null or undefined when calling updateTutorial().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tutorials/{tutorial_id}`.replace(`{${"tutorial_id"}}`, encodeURIComponent(String(requestParameters['tutorialId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TutorialUpdateToJSON(requestParameters['tutorialUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TutorialReadFromJSON(jsonValue));
    }

    /**
     * Update a tutorial.  **Authorization:** Only tutorial creator or superadmins.
     * Update Tutorial
     */
    async updateTutorial(requestParameters: UpdateTutorialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TutorialRead> {
        const response = await this.updateTutorialRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
